import { Dimensions, Platform, StatusBar, View } from "react-native";
import React, { useEffect } from "react";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import BootSplash from "react-native-bootsplash";
import Orientation from "react-native-orientation-locker";
import RootRoute from "./src/screens/RootRoute";
import { persistor, store } from "./src/redux/store";
import { AppTheme } from "./src/utils/theme";
import ErrorBoundary from "react-native-error-boundary";
import FallbackComponent from "./src/components/global/ErrorFallBack";
import InAppNotifications from "./src/screens/InAppNotifications";
import Toast from "react-native-toast-message";
import { toastConfig } from "./src/components/global/ToastConfig";
import AppLoadingFallback from "./src/components/global/AppLoadingFallback";

const initialMetrics =
  Platform.OS === "web"
    ? {
      insets: { top: 0, left: 0, right: 0, bottom: 0 },
      frame: {
        x: 0,
        y: 0,
        width: Dimensions.get("window")?.width || 480,
        height: Dimensions.get("window")?.height || 800,
      },
    }
    : undefined;

const App: React.FC = () => {
  useEffect(() => {
    const init = async () => {
      // …do multiple sync or async tasks
    };

    init().finally(async () => {
      await BootSplash.hide({ fade: true });
    });
    Orientation.lockToPortrait();
  }, []);

  return (
    <SafeAreaProvider initialMetrics={initialMetrics}>
      <ErrorBoundary FallbackComponent={FallbackComponent}>
        <SafeAreaView
          style={{
            flex: 1,
            width: "100%",
            maxWidth: Platform.OS === "web" ? 480 : undefined,
            alignSelf: "center",
          }}
          edges={{
            bottom: Platform.OS == "android" ? "additive" : "off",
            top: "off",
          }}
        >
          <GestureHandlerRootView style={{ flex: 1 }}>
            <Provider store={store}>
              <PersistGate loading={<AppLoadingFallback />} persistor={persistor}>
                <StatusBar
                  translucent
                  barStyle={"light-content"}
                  backgroundColor={`${AppTheme.colors.white}01`}
                />
                <View style={{ flex: 1 }}>
                  <InAppNotifications />
                  <RootRoute />
                  <Toast config={toastConfig} />
                </View>
              </PersistGate>
            </Provider>
          </GestureHandlerRootView>
        </SafeAreaView>
      </ErrorBoundary>
    </SafeAreaProvider>
  );
};

export default App;
